@if (showLegacyStandardPayment) {
  <div class="tw-flex tw-flex-col tw-h-full tw-overflow-y-auto tw-bg-gray-100">
    @if (!paymentMethods.length) {
      <loading class="tw-flex-1 tw-self-center tw-justify-self-center"></loading>
    }
    @if (paymentMethods.length) {
      <div class="tw-w-10 tw-h-10 tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl" (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
      </div>
      <section class="tw-px-6 tw-pt-16 tw-pb-5 tw-bg-teal-100">
        @if (offerTimer.endTime > 0 && order.get("type") === appConfig.Shared.Order.Type.REGIMEN) {
          <p class="fontR">
            <discount-timer [endTime]="offerTimer.endTime" [text]="offerTimer.title"></discount-timer>
          </p>
        }
      </section>
      <section class="tw-px-6 tw-sticky tw-top-0 tw-relative tw-pt-4 tw-z-[30] tw-bg-teal-100">
        <div class="tw-sticky tw-top-0">
          @if (order) {
            <p class="tw-text-100 tw-font-body tw-text-black tw-uppercase tw-tracking-[1px]" i18n="@@totalPayment"> Total Payment </p>
          }
          <h1 class="tw-text-900 tw-font-body tw-text-black tw-mb-4">
            @if (discount) {
              <del>₹ <span>{{orderMRP}}</span>
            </del>
          }
          @if (orderBeforeOfferPrice) {
            <del class="tw-font-bold">&nbsp;₹{{orderBeforeOfferPrice}}</del>
          }
          <span class="tw-font-bold tw-whitespace-nowrap tw-text-teal-600">&nbsp;₹{{orderSP}} &nbsp;</span>
        </h1>
      </div>
    </section>
    <section class="tw-px-4 tw-bg-teal-100 tw-pb-5">
      @if (appliedCoupon || (discount > 5)) {
        <div class="tw-flex tw-items-center tw-gap-4 tw-mb-2 tw-px-2">
          <div class="tw-flex tw-items-center">
            <div class="svg-container tw-relative">
              <svg class="anim-image" xmlns="http://www.w3.org/2000/svg" width="64.443" height="67.447" viewBox="0 0 64.443 67.447">
                <path id="Path_23051" data-name="Path 23051" d="M87.025,208.059,79.5,203.146l-2.347-8.676a3.039,3.039,0,0,0-3.088-2.243l-8.976.449-7-5.639a3.042,3.042,0,0,0-3.817,0l-7,5.639-8.975-.449a3.031,3.031,0,0,0-3.088,2.243l-2.347,8.676-7.525,4.912a3.042,3.042,0,0,0-1.179,3.63l3.2,8.4-3.2,8.4a3.042,3.042,0,0,0,1.179,3.63l7.525,4.913,2.347,8.675a3.034,3.034,0,0,0,3.088,2.243l8.975-.449,7,5.639a3.041,3.041,0,0,0,3.817,0l7-5.639,8.976.449a3.036,3.036,0,0,0,3.088-2.243l2.347-8.675,7.525-4.913a3.042,3.042,0,0,0,1.179-3.63l-3.2-8.4,3.2-8.4A3.042,3.042,0,0,0,87.025,208.059Z" transform="translate(-23.961 -186.363)" fill="#00AB5E"></path>
              </svg>
              <span class="off">%</span>
            </div>
          </div>
          <div class="tw-flex tw-flex-col">
            @if (discount && +discount >= 5) {
              <p class="tw-font-body tw-font-bold tw-text-100 tw-text-black" i18n="@@discountApplied">
            {{discount}}% instant discount applied
          </p>
            }
            @if (appliedWalletBalance) {
              <p class="tw-font-body tw-text-200 tw-text-black">
                <span class="fw700 clr-dark" i18n="@@cashApplied">{{appliedWalletBalance.amount%1 != 0 ?
        appliedWalletBalance.amount.toFixed(2) :
        appliedWalletBalance.amount}} Cure cash used =</span>
                <span>- ₹{{appliedWalletBalance.amount%1 != 0 ?
                  appliedWalletBalance.amount.toFixed(2) :
                appliedWalletBalance.amount}}</span>
              </p>
            }
            @if (appliedCoupon) {
              <p class="tw-font-body tw-text-200 tw-text-black">
                <span i18n="@@couponApplied">Coupon "{{appliedCoupon.code}}" has been applied =</span>
                <span>- ₹{{appliedCoupon.amount}}.</span>
              </p>
            }
            @if (showNewCrossSellDiscountDisclaimer) {
              <p class="tw-font-body tw-text-200"><span i18n="@@extraDiscountOnSecondRegimen"><span class="tw-font-bold">Extra discount</span> on 2nd treatment kit =</span> -₹{{ crossSellDiscountAmount }}</p>
            }
            @if ((orderMRP - orderSP) > 0) {
              <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@youHaveSavedAmountNew"> You are saving ₹{{orderMRP - orderSP}} on this order </p>
            }
            @if (isCodHandlingFeeEnabled && codHandlingFee > 0 && selectedPaymentMode === appConfig.Shared.Payment.paymentModes.COD) {
              <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@handlingChargesAdded"> ₹{{codHandlingFee}} handling charges added </p>
            }
          </div>
        </div>
      }
    </section>
    <ng-container *ngTemplateOutlet="cureskinCashAppliedStrip"></ng-container>
    <ng-container *ngTemplateOutlet="applyCashUI"></ng-container>
  }
  @if (order) {
    <section class="tw-flex-1 tw-bg-white tw-pb-20" id="paymentPage" #paymentPage="">
      @if (order.get("paidAmount")) {
        <div class="partialAmount" i18n="@@partialPaymentReceived"> We have received Rs {{order.get("paidAmount")}}. You will be paying only Rs {{orderSP - order.get("paidAmount")}} for this order. </div>
      }
      @for (banner of banners; track banner) {
        <img class="banner" [src]="banner.image" />
      }
      @for (paymentMethod of paymentMethods; track paymentMethod; let i = $index) {
        <div class="payments" [id]="paymentMethod.mode" [attr.data-testid]="'payment-option-' + paymentMethod.mode.toLowerCase()" (click)="onPaymentMethodTap(paymentMethod.mode)"
          [class.no-bdr]="i === 0"
          [class.tw-opacity-locked]="isPaymentSelectionLocked"
          [class.tw-pointer-events-none]="isPaymentSelectionLocked">
          <div class="image">
            @if (paymentMethod.img) {
              <img [src]="paymentMethod.img" alt="service_image" [class]="paymentMethod.title" [ngStyle]="{ 'opacity': (disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) ? '0.2' : '1' }" />
            }
          </div>
          <div class="title">
            <div id="paymentMethodTitle" class="tw-font-body" [ngStyle]="{ 'color': (disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) ? 'var(--grey-400, #9E9E9E)' : 'inherit' }">
              {{getTranslatedString(paymentMethod.title)}}
            </div>
            @if (paymentMethod.mode === appConfig.Shared.Payment.paymentModes.UPI) {
              <div class="sub tw-font-body" i18n="@@gPayPhonePe"> Google Pay, PhonePe, BHIM and more </div>
            }
            @if (paymentMethod.mode === appConfig.Shared.Payment.paymentModes.WALLET) {
              <div class="sub tw-font-body" i18n="@@amazonOla"> Amazon Pay, Ola Money and more </div>
            }
            @if (disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) {
              <div class="sub tw-font-body" i18n="@@codUnavailable"> (Not available for this order) </div>
            }
            @if (showCCODCharge && !disableCod) {
              @if (paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD && CCODInfo?.amount) {
                <div class="sub fontS2 tw-text-orange-400 bolder tw-font-body" i18n="@@processingFeeOnline"> ₹{{CCODInfo?.amount}} processing fee to be paid online </div>
                <div class="sub fontS3 tw-text-gray-400 bolder tw-font-body" i18n="@@nonRefundable"> This is non refundable </div>
              }
            }
            @if (paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD && isCodHandlingFeeEnabled) {
              <p class="tw-w-full tw-mt-1 tw-text-200 tw-text-gray-400 tw-font-bold tw-font-body">₹{{codHandlingFee}} <span i18n="@@handlingChargesApply">handling charges apply</span> </p>
            }
          </div>
          @if (paymentMethod.mode !== appConfig.Shared.Payment.paymentModes.COD) {
            <div class="selection">
              <ng-container *ngTemplateOutlet="paymentSelectionRadio; context: { paymentMethod: paymentMethod }"></ng-container>
            </div>
          }
          @if (disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) {
            <div class="selection">
              <div class="unselected" [ngStyle]="{'background': 'var(--grey-100, #F3F3F3)'}"></div>
            </div>
          }
          @if (!disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) {
            <div class="selection">
              <ng-container *ngTemplateOutlet="paymentSelectionRadio; context: { paymentMethod: paymentMethod }"></ng-container>
            </div>
          }
        </div>
      }
      <ng-container *ngTemplateOutlet="sharePaymentLinkRow"></ng-container>
      @if (enableOtherPayments) {
        <div class="otherPayments" id="otherPayments" (click)="openRazorpayHome()"
          [class.tw-opacity-locked]="isPaymentSelectionLocked"
          [class.tw-pointer-events-none]="isPaymentSelectionLocked">
          <div class="dots">
            <em></em>
            <em></em>
            <em></em>
          </div>
          <div class="flex-grow tw-font-body" i18n="@@otherPayment"> Other Payment Methods </div>
          <em class="cs-icon-arrow fontL2 tw-text-teal-600"></em>
        </div>
      }
      <form method="post" action="{{paytmServerUrl}}" name="formPaytm">
        <table border="1">
          @if (paytmConfig) {
            <tbody>
              <input type="hidden" name="MID" value="{{paytmConfig.MID}}" />
              <input type="hidden" name="ORDER_ID" value="{{paytmConfig.ORDER_ID}}" />
              <input type="hidden" name="CUST_ID" value="{{paytmConfig.CUST_ID}}" />
              <input type="hidden" name="WEBSITE" value="{{paytmConfig.WEBSITE}}" />
              <input type="hidden" name="CHANNEL_ID" value="{{paytmConfig.CHANNEL_ID}}" />
              <input type="hidden" name="EMAIL" value="{{paytmConfig.EMAIL}}" />
              <input type="hidden" name="MOBILE_NO" value="{{paytmConfig.MOBILE_NO}}" />
              <input type="hidden" name="CALLBACK_URL" value="{{paytmConfig.CALLBACK_URL}}" />
              <input type="hidden" name="INDUSTRY_TYPE_ID" value="{{paytmConfig.INDUSTRY_TYPE_ID}}" />
              <input type="hidden" name="TXN_AMOUNT" value="{{paytmConfig.TXN_AMOUNT}}" />
              <input type="hidden" name="CHECKSUMHASH" value="{{paytmConfig.CHECKSUMHASH}}" />
            </tbody>
          }
        </table>
        <div class="tw-bg-gray-100 tw-flex tw-flex-col">
          <ng-container *ngTemplateOutlet="chooseCouponUI"></ng-container>
          @if (disableCod) {
            <div id="disabledCod" class="tw-mt-4 tw-mx-5 tw-py-3 tw-px-4 tw-border tw-border-gray-200 tw-bg-[#f9f9f9] tw-rounded-2"
              [class.tw-opacity-locked]="isPaymentSelectionLocked">
              <p class="tw-text-gray-500 tw-text-200 tw-font-medium">(<span>This order is not eligible for COD</span>)</p>
            </div>
          }
          <ng-container *ngTemplateOutlet="haveACouponCodeSection"></ng-container>
        </div>
      </form>
      @if (order && selectedPaymentMode) {
        <footer class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-flex tw-px-6 tw-py-4 tw-bg-white">
          @if (showOrderDetail) {
            <div class="underline fontS2 mB15" (click)="showOrderDetailsPopup()" i18n="@@clickHereForOrderDetails"> Click here for order details </div>
          }
          <div class="w100">
            <ng-container *ngTemplateOutlet="noCodConfirmationFeeButtons"></ng-container>
          </div>
        </footer>
      }
    </section>
  }
</div>
}

@if (showLegacyPrepaidPayment) {
  <div class="tw-flex tw-flex-col tw-h-full tw-overflow-y-auto tw-bg-gray-100">
    @if (!paymentMethods.length || paymentProcessing) {
      <loading class="tw-flex-1 tw-self-center tw-justify-self-center"></loading>
    }
    @if (paymentMethods.length && !paymentProcessing) {
      <div class="tw-fixed tw-left-6 tw-top-6 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10" (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
      </div>
      <section class="tw-px-6 tw-pt-16 tw-pb-5 tw-bg-teal-100">
        @if (offerTimer.endTime > 0 && order.get("type") === appConfig.Shared.Order.Type.REGIMEN) {
          <p class="fontR">
            <discount-timer [endTime]="offerTimer.endTime" [text]="offerTimer.title"></discount-timer>
          </p>
        }
      </section>
      <section class="tw-px-6 tw-sticky tw-top-0 tw-relative tw-pt-4 tw-z-[30] tw-bg-teal-100">
        <div class="tw-sticky tw-top-0">
          @if (order) {
            <p class="tw-font-body tw-text-100 tw-text-black tw-uppercase tw-tracking-[1px]" i18n="@@totalPayment"> Total Payment </p>
          }
          <h1 class="tw-font-body tw-text-900 tw-text-black tw-mb-4">
            @if (discount) {
              <del>₹ <span>{{orderMRP}}</span>
            </del>
          }
          @if (orderBeforeOfferPrice) {
            <del class="tw-font-bold">&nbsp;₹{{orderBeforeOfferPrice}}</del>
          }
          <span class="tw-font-bold tw-text-teal-600">&nbsp;₹{{orderSP}} &nbsp;</span>
        </h1>
      </div>
    </section>
    <section class="tw-px-6 tw-bg-teal-100 tw-pb-5">
      @if (appliedCoupon || discount) {
        <div class="tw-flex tw-items-center tw-gap-4 tw-mb-2">
          <div class="tw-flex tw-items-center">
            <div class="tw-relative svg-container ">
              <svg class="anim-image" xmlns="http://www.w3.org/2000/svg" width="64.443" height="67.447" viewBox="0 0 64.443 67.447">
                <path id="Path_23051" data-name="Path 23051" d="M87.025,208.059,79.5,203.146l-2.347-8.676a3.039,3.039,0,0,0-3.088-2.243l-8.976.449-7-5.639a3.042,3.042,0,0,0-3.817,0l-7,5.639-8.975-.449a3.031,3.031,0,0,0-3.088,2.243l-2.347,8.676-7.525,4.912a3.042,3.042,0,0,0-1.179,3.63l3.2,8.4-3.2,8.4a3.042,3.042,0,0,0,1.179,3.63l7.525,4.913,2.347,8.675a3.034,3.034,0,0,0,3.088,2.243l8.975-.449,7,5.639a3.041,3.041,0,0,0,3.817,0l7-5.639,8.976.449a3.036,3.036,0,0,0,3.088-2.243l2.347-8.675,7.525-4.913a3.042,3.042,0,0,0,1.179-3.63l-3.2-8.4,3.2-8.4A3.042,3.042,0,0,0,87.025,208.059Z" transform="translate(-23.961 -186.363)" fill="#00AB5E"></path>
              </svg>
              <span class="off">%</span>
            </div>
          </div>
          <div class="tw-flex tw-flex-col">
            @if (discount && +discount >= 5) {
              <p class="tw-font-body tw-font-bold tw-text-100 tw-text-black" i18n="@@discountApplied">
            {{discount}}% instant discount applied
          </p>
            }
            @if (appliedWalletBalance) {
              <p class="tw-font-body tw-text-200 tw-text-black">
                <span class="clr-dark fw700" i18n="@@cashApplied">{{appliedWalletBalance.amount%1 != 0 ?
        appliedWalletBalance.amount.toFixed(2) :
        appliedWalletBalance.amount}} Cure cash used =</span>
                <span>- ₹{{appliedWalletBalance.amount%1 != 0 ?
                  appliedWalletBalance.amount.toFixed(2) :
                appliedWalletBalance.amount}}</span>
              </p>
            }
            @if (appliedCoupon && appliedCoupon?.code !== prepaidDiscountCoupon ) {
              <p class="tw-font-body tw-text-200 tw-text-black">
                <span i18n="@@couponApplied">Coupon "{{appliedCoupon.code}}" has been applied =</span>
                <span>- ₹{{appliedCoupon.amount}}.</span>
              </p>
            }
            @if ((orderMRP - orderSP) > 0) {
              <p class="tw-font-body tw-text-200 tw-text-black" i18n="@@youHaveSavedAmountNew"> You are saving ₹{{orderMRP - orderSP}} on this order </p>
            }
          </div>
        </div>
      }
    </section>
    <ng-container *ngTemplateOutlet="cureskinCashAppliedStrip"></ng-container>
    <ng-container *ngTemplateOutlet="applyCashUI"></ng-container>
  }
  @if (order && !paymentProcessing) {
    <section class="tw-flex-1 tw-bg-white tw-pb-20" id="paymentPage" #paymentPage="">
      @if (order.get("paidAmount")) {
        <div class="partialAmount" i18n="@@partialPaymentReceived"> We have received Rs {{order.get("paidAmount")}}. You will be paying only Rs {{orderSP - order.get("paidAmount")}} for this order. </div>
      }
      @for (banner of banners; track banner) {
        <img class="banner" [src]="banner.image" />
      }
      @for (paymentMethod of paymentMethods; track paymentMethod; let i = $index) {
        <div class="payments" [id]="paymentMethod.mode" [attr.data-testid]="'payment-option-' + paymentMethod.mode.toLowerCase()" (click)="onPaymentMethodTap(paymentMethod.mode)"
          [class.no-bdr]="i === 0"
          [class.tw-opacity-locked]="isPaymentSelectionLocked"
          [class.tw-pointer-events-none]="isPaymentSelectionLocked">
          <div class="image">
            @if (paymentMethod.img) {
              <img [src]="paymentMethod.img" alt="service_image" [ngStyle]="{ 'opacity': (disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) ? '0.2' : '1' }" [class]="paymentMethod.title" />
            }
          </div>
          <div class="title">
            <div id="paymentMethodTitle" class="tw-font-body" [ngStyle]="{ 'color': (disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) ? 'var(--grey-400, #9E9E9E)' : 'inherit' }">
              {{getTranslatedString(paymentMethod.title)}}
            </div>
            @if (paymentMethod.mode === appConfig.Shared.Payment.paymentModes.UPI) {
              <div class="sub tw-font-body" i18n="@@gPayPhonePe"> Google Pay, PhonePe, BHIM and more </div>
            }
            @if (paymentMethod.mode === appConfig.Shared.Payment.paymentModes.WALLET) {
              <div class="sub tw-font-body" i18n="@@amazonOla"> Amazon Pay, Ola Money and more </div>
            }
            @if (disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) {
              <div class="sub tw-font-body" i18n="@@codUnavailable"> (Not available for this order) </div>
            }
            @if (showPrepaidDiscountInfo && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.UPI) {
              <div class="sub tw-font-body  tw-font-bold tw-text-200" class="tw-text-teal-600" i18n="@@prepaidDiscount"> ₹100 off with online coupon </div>
            }
            @if (showCCODCharge && !disableCod) {
              @if (paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD && CCODInfo?.amount) {
                <div class="sub fontS2 tw-font-body tw-text-orange-400 bolder" i18n="@@processingFeeOnline"> ₹{{CCODInfo?.amount}} processing fee to be paid online </div>
                <div class="sub fontS3 tw-text-gray-400 bolder tw-font-body" i18n="@@nonRefundable"> This is non refundable </div>
              }
            }
            @if (paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD && isCodHandlingFeeEnabled) {
              <p class="tw-w-full tw-mt-1 tw-text-200 tw-text-gray-400 tw-font-bold tw-font-body">₹{{codHandlingFee}} <span i18n="@@handlingChargesApply">handling charges apply</span> </p>
            }
          </div>
          @if (paymentMethod.mode !== appConfig.Shared.Payment.paymentModes.COD) {
            <div class="selection">
              <ng-container *ngTemplateOutlet="paymentSelectionRadio; context: { paymentMethod: paymentMethod }"></ng-container>
            </div>
          }
          @if (disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) {
            <div class="selection">
              <div class="unselected" [ngStyle]="{'background': 'var(--grey-100, #F3F3F3)'}"></div>
            </div>
          }
          @if (!disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) {
            <div class="selection">
              <ng-container *ngTemplateOutlet="paymentSelectionRadio; context: { paymentMethod: paymentMethod }"></ng-container>
            </div>
          }
        </div>
      }
      <ng-container *ngTemplateOutlet="sharePaymentLinkRow"></ng-container>
      @if (enableOtherPayments) {
        <div id="otherPayments" class="otherPayments" (click)="openRazorpayHome()"
          [class.tw-opacity-locked]="isPaymentSelectionLocked"
          [class.tw-pointer-events-none]="isPaymentSelectionLocked">
          <div class="dots">
            <em></em>
            <em></em>
            <em></em>
          </div>
          <div class="flex-grow tw-font-body" i18n="@@otherPayment"> Other Payment Methods </div>
          <em class="cs-icon-arrow fontL2 tw-text-teal-600"></em>
        </div>
      }
      <form name="formPaytm" method="post" action="{{paytmServerUrl}}">
        <table border="1">
          @if (paytmConfig) {
            <tbody>
              <input type="hidden" name="MID" value="{{paytmConfig.MID}}" />
              <input type="hidden" name="ORDER_ID" value="{{paytmConfig.ORDER_ID}}" />
              <input type="hidden" name="CUST_ID" value="{{paytmConfig.CUST_ID}}" />
              <input type="hidden" name="WEBSITE" value="{{paytmConfig.WEBSITE}}" />
              <input type="hidden" name="CHANNEL_ID" value="{{paytmConfig.CHANNEL_ID}}" />
              <input type="hidden" name="EMAIL" value="{{paytmConfig.EMAIL}}" />
              <input type="hidden" name="MOBILE_NO" value="{{paytmConfig.MOBILE_NO}}" />
              <input type="hidden" name="CALLBACK_URL" value="{{paytmConfig.CALLBACK_URL}}" />
              <input type="hidden" name="INDUSTRY_TYPE_ID" value="{{paytmConfig.INDUSTRY_TYPE_ID}}" />
              <input type="hidden" name="TXN_AMOUNT" value="{{paytmConfig.TXN_AMOUNT}}" />
              <input type="hidden" name="CHECKSUMHASH" value="{{paytmConfig.CHECKSUMHASH}}" />
            </tbody>
          }
        </table>
        <div class="tw-bg-gray-100 tw-flex tw-flex-col">
          <ng-container *ngTemplateOutlet="chooseCouponUI"></ng-container>
          @if (disableCod) {
            <div id="disabledCod" class="tw-mt-4 tw-mx-5 tw-py-3 tw-px-4 tw-border tw-border-gray-200 tw-bg-[#f9f9f9] tw-rounded-2"
              [class.tw-opacity-locked]="isPaymentSelectionLocked">
              <p class="tw-text-gray-500 tw-text-200 tw-font-medium">(<span>This order is not eligible for COD</span>)</p>
            </div>
          }
          <ng-container *ngTemplateOutlet="haveACouponCodeSection"></ng-container>
        </div>
      </form>
      @if (order && selectedPaymentMode) {
        <footer class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-flex tw-px-6 tw-py-4 tw-bg-white">
          @if (showOrderDetail) {
            <div class="underline fontS2 mB15" (click)="showOrderDetailsPopup()" i18n="@@clickHereForOrderDetails"> Click here for order details </div>
          }
          <div class="w100">
            <ng-container *ngTemplateOutlet="noCodConfirmationFeeButtons"></ng-container>
          </div>
        </footer>
      }
    </section>
  }
</div>
}

@if (orderFlowHeader) {
  <div class="tw-flex tw-h-full tw-flex-col tw-overflow-y-auto tw-bg-gray-100">
    @if (!paymentMethods.length) {
      <loading class="tw-flex-1 tw-self-center tw-justify-self-center"></loading>
    } @else {
      <div class="tw-sticky tw-top-0 tw-z-10 tw-shrink-0 tw-bg-teal-100 tw-px-6 tw-pb-3 tw-pt-6">
        <div class="tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-text-gray-800" (click)="back()">
          <cs-icon class="tw-h-full tw-w-full" [iconName]="'arrow_left'"></cs-icon>
        </div>
      </div>
      <section class="tw-relative tw-bg-teal-100 tw-px-6 tw-pb-6">
        @if (showRegimenOfferTimer) {
          <discount-timer [endTime]="offerTimer.endTime" [text]="offerTimer.title"></discount-timer>
        }
        <p class="tw-mt-2 tw-font-lexend tw-text-200 tw-text-gray-500" i18n="@@payment">Payment</p>
        <div class="tw-mt-2 tw-flex tw-items-baseline tw-gap-2">
          @if (orderMRP > orderSP) {
            <span class="tw-font-lexend tw-text-750 tw-font-light tw-text-gray-800 tw-line-through">₹{{orderMRP}}</span>
          }
          <span class="tw-font-lexend tw-text-900 tw-font-bold tw-text-teal-600">₹{{orderSP}}</span>
        </div>
        @if (showOrderFlowSummaryBreakup) {
          <div class="tw-my-3 tw-h-px tw-w-full tw-bg-gray-300 tw-mix-blend-multiply"></div>
          @if (appliedWalletBalance) {
            <p class="tw-font-body tw-text-200 tw-text-gray-800" i18n="@@yayCureCashApplied">Yay! ₹{{appliedWalletBalance.amount % 1 != 0 ? appliedWalletBalance.amount.toFixed(2) : appliedWalletBalance.amount}} cure cash <img class="tw-mx-0.5 tw-mb-0.5 tw-inline-block tw-h-3 tw-w-3" src="/assets/images/cureskin-cash-icon.png" alt="" /> applied!</p>
          }
          @if (showOrderFlowAppliedCoupon) {
            <p class="tw-font-body tw-text-200 tw-text-gray-800">
              <span i18n="@@couponApplied">Coupon "{{appliedCoupon.code}}" has been applied =</span>
              <span>- ₹{{appliedCoupon.amount}}.</span>
            </p>
          }
          @if ((orderMRP - orderSP) > 0) {
            <div class="tw-flex tw-items-center tw-gap-1">
              @if (!appliedWalletBalance) {
                <img class="tw-h-4 tw-w-4 tw-shrink-0 tw-object-contain" src="/assets/images/offer-icon.png" alt="" />
              }
              <p class="tw-font-body tw-text-200 tw-text-gray-800" i18n="@@totalDiscountApplied">₹{{orderMRP - orderSP}} Total discount applied!</p>
            </div>
          }
        }
      </section>

      <ng-container *ngTemplateOutlet="applyCashUI"></ng-container>

      <section class="tw-flex tw-flex-col tw-pb-40 tw-mt-2">
        @for (paymentMethod of orderFlowPaymentMethods; track paymentMethod) {
          <div class="tw-flex tw-h-18 tw-items-center tw-justify-between tw-border-b tw-border-solid tw-border-gray-200 tw-px-4"
            [id]="paymentMethod.mode"
            [attr.data-testid]="'payment-option-' + paymentMethod.mode.toLowerCase()"
            [class.tw-bg-blue-25]="paymentMethod.mode === selectedPaymentMode"
            [class.tw-bg-gray-75]="paymentMethod.mode !== selectedPaymentMode"
            [class.tw-opacity-locked]="isPaymentSelectionLocked"
            [class.tw-pointer-events-none]="isPaymentSelectionLocked"
            (click)="onPaymentMethodTap(paymentMethod.mode)">
            <div class="tw-flex tw-items-center tw-gap-2"
              [class.tw-opacity-20]="disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD">
              @if (paymentMethod.img) {
                <img class="tw-h-6 tw-w-6 tw-shrink-0 tw-object-contain" [src]="paymentMethod.img" alt="" />
              }
              <div class="tw-flex tw-flex-col">
                <p class="tw-font-lexend tw-text-300 tw-font-medium tw-text-gray-800">{{getTranslatedString(paymentMethod.title)}}</p>
                @if (paymentMethod.mode === appConfig.Shared.Payment.paymentModes.UPI) {
                  <p class="tw-font-body tw-text-100 tw-text-gray-500" i18n="@@gPayPhonePe"> Google Pay, PhonePe, BHIM and more </p>
                }
                @if (paymentMethod.mode === appConfig.Shared.Payment.paymentModes.WALLET) {
                  <p class="tw-font-body tw-text-100 tw-text-gray-500" i18n="@@amazonOla"> Amazon Pay, Ola Money and more </p>
                }
                @if (disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) {
                  <p class="tw-font-body tw-text-100 tw-text-gray-400" i18n="@@codUnavailable"> (Not available for this order) </p>
                }
                @if (showPrepaidDiscountInfo && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.UPI) {
                  <p class="tw-font-body tw-text-100 tw-font-bold tw-text-teal-600" i18n="@@prepaidDiscount"> ₹100 off with online coupon </p>
                }
                @if (showCCODCharge && !disableCod && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD && CCODInfo?.amount) {
                  <p class="tw-font-body tw-text-100 tw-font-bold tw-text-orange-400" i18n="@@processingFeeOnline"> ₹{{CCODInfo?.amount}} processing fee to be paid online </p>
                  <p class="tw-font-body tw-text-100 tw-font-bold tw-text-gray-400" i18n="@@nonRefundable"> This is non refundable </p>
                }
                @if (isCodHandlingFeeEnabled && paymentMethod.mode === appConfig.Shared.Payment.paymentModes.COD) {
                  <p class="tw-font-body tw-text-100 tw-font-bold tw-text-gray-400">₹{{codHandlingFee}} <span i18n="@@handlingChargesApply">handling charges apply</span></p>
                }
              </div>
            </div>
            <cs-icon class="tw-h-6 tw-w-6 tw-shrink-0"
              [class.tw-text-teal-600]="paymentMethod.mode === selectedPaymentMode"
              [class.tw-text-gray-400]="paymentMethod.mode !== selectedPaymentMode"
              [iconName]="paymentMethod.mode === selectedPaymentMode ? 'radio_button_checked' : 'radio_button_unchecked'"></cs-icon>
          </div>
        }

        @if (disabledCodPaymentMethod) {
          <div id="disabledCod" class="tw-flex tw-h-18 tw-items-center tw-justify-between tw-border-b tw-border-solid tw-border-gray-200 tw-bg-gray-75 tw-px-4"
            [class.tw-opacity-locked]="isPaymentSelectionLocked">
            <div class="tw-flex tw-items-center tw-gap-2">
              @if (disabledCodPaymentMethod.img) {
                <img class="tw-h-6 tw-w-6 tw-shrink-0 tw-object-contain" [class.tw-opacity-40]="!isPaymentSelectionLocked" [src]="disabledCodPaymentMethod.img" alt="" />
              }
              <div class="tw-flex tw-flex-col">
                <p class="tw-font-lexend tw-text-300 tw-font-medium tw-text-gray-400">{{getTranslatedString(disabledCodPaymentMethod.title)}}</p>
                <p class="tw-font-body tw-text-100 tw-text-gray-400" i18n="@@notEligibleForCod">This order is not eligible for COD</p>
              </div>
            </div>
          </div>
        }

        @if (showOrderFlowShareLink) {
          <div elementInViewport [viewportObserveOnce]="true" (enteredViewport)="logSharePaymentLinkImpression()"
            class="tw-flex tw-h-18 tw-items-center tw-justify-between tw-border-b tw-border-solid tw-border-gray-200 tw-bg-gray-75 tw-px-4" (click)="openSharePaymentLinkSheet()">
            <div class="tw-flex tw-items-center tw-gap-2">
              <img class="tw-h-6 tw-w-6 tw-shrink-0 tw-object-contain" src="/assets/icons/people-icon-payment-page.png" alt="" />
              <div class="tw-flex tw-flex-col">
                <p class="tw-font-lexend tw-text-300 tw-font-medium tw-text-gray-800" i18n="@@sharePaymentLink">Share payment link</p>
                <p class="tw-font-body tw-text-100 tw-text-gray-500" i18n="@@sharePaymentLinkSubtextInline">Let a family member or friend pay for you</p>
              </div>
            </div>
            <img class="tw-h-6 tw-w-6 tw-shrink-0" src="/assets/icons/teal-green-share-payment-page.png" alt="" />
          </div>
        }

        @if (enableOtherPayments) {
          <div class="tw-flex tw-h-18 tw-items-center tw-justify-between tw-px-4" role="button" tabindex="0"
            [class.tw-bg-blue-25]="selectedPaymentMode === appConfig.Shared.Payment.paymentModes.OTHER"
            [class.tw-bg-gray-75]="selectedPaymentMode !== appConfig.Shared.Payment.paymentModes.OTHER"
            [class.tw-opacity-locked]="isPaymentSelectionLocked"
            [class.tw-pointer-events-none]="isPaymentSelectionLocked"
            (click)="selectOtherPaymentMethod()"
            (keydown.enter)="selectOtherPaymentMethod()"
            (keydown.space)="selectOtherPaymentMethod()">
            <div class="tw-flex tw-items-center tw-gap-2">
              <cs-icon class="tw-h-6 tw-w-6 tw-shrink-0" [iconName]="'other_payment_dots'"></cs-icon>
              <p class="tw-font-lexend tw-text-300 tw-font-medium tw-text-gray-800" i18n="@@otherPayment"> Other Payment Methods </p>
            </div>
            <cs-icon class="tw-h-4 tw-w-4 tw-text-teal-600" [iconName]="'arrow_forward_ios'"></cs-icon>
          </div>
        }

        @if (showOrderFlowCoupon) {
          <div class="tw-mx-4 tw-mt-4 tw-flex tw-flex-col tw-gap-3 tw-rounded-2 tw-bg-gray-75 tw-p-4 tw-shadow-z4">
            <div class="tw-flex tw-items-center tw-gap-1">
              <cs-icon class="tw-h-4 tw-w-4 tw-text-yellow-400" [iconName]="'coupon_tag'"></cs-icon>
              <p class="tw-font-lexend tw-text-300 tw-font-bold tw-text-gray-800" i18n="@@haveACouponCode"> Have a coupon code? </p>
            </div>
            <div class="tw-flex tw-items-start tw-gap-2">
              <input type="text"
                class="tw-h-8 tw-flex-1 tw-rounded-2 tw-border tw-border-solid tw-border-gray-200 tw-bg-gray-100 tw-px-2 tw-font-lexend tw-text-200 tw-text-gray-800 placeholder:tw-text-gray-400"
                placeholder="Enter coupon code" i18n-placeholder="@@enterCouponCode"
                [(ngModel)]="couponCode" [disabled]="couponLoading" />
              <button type="button"
                class="tw-flex tw-h-8 tw-w-20 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-2 tw-font-lexend tw-text-300 tw-font-semibold tw-capitalize tw-text-white"
                [class.tw-bg-gray-400]="!couponCode"
                [class.tw-bg-teal-600]="couponCode"
                (click)="applyCoupon(selectedPaymentMode)">
                @if (!couponLoading) { <span i18n="@@apply">Apply</span> }
                @if (couponLoading) { <loading [scale]="0.6"></loading> }
              </button>
            </div>
          </div>
        }
      </section>

      @if (isOrderFlowFooterVisible) {
        <footer class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-gray-75 tw-px-4 tw-pb-8 tw-pt-6">
          @if (!isPlaceOrderMode) {
            <button csButton type="button" class="tw-w-full !tw-rounded-3"
              [disabled]="!selectedPaymentMode" [loading]="loading" data-testid="place-order" (click)="placeOrder()" i18n="@@pay">Pay</button>
          } @else {
            <button csButton type="button" class="tw-w-full !tw-rounded-3"
              [disabled]="!selectedPaymentMode" [loading]="loading" data-testid="place-order" (click)="placeOrder()" i18n="@@placeYourOrder">place your order</button>
          }
        </footer>
      }
    }
  </div>
}

@if (popUp.open && popUp.type === "ORDER_SUMMARY") {
  <pop-up [show]="true">
    <order-summary-popup [data]="orderSummary" [experiments]="experiments" (close)="back()"></order-summary-popup>
  </pop-up>
}

<ng-template #cureskinCashAppliedStrip>
  @if (appliedWalletBalance && !canPayFullyWithCureskinCash) {
    <section class="cashStrip card tw-items-center tw-gap-4 tw-rounded-2xl tw-px-5 tw-py-2 tw-mx-4 tw-bg-white tw-relative tw-top-[-15px]">
      <div class="tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-flex-row">
          <div class="tw-flex tw-items-center tw-justify-center tw-rounded-xl" (click)="back()">
            <cs-icon class="tw-h-6 tw-w-6" [iconName]="'cureskin_cash_coin'"></cs-icon>
          </div>
          <span class="tw-ml-1 tw-flex tw-flex-row tw-items-center">
            <p class="tw-font-bold tw-font-body tw-text-600">
              {{appliedWalletBalance.amount%1 != 0 ?
              appliedWalletBalance.amount.toFixed(2) :
              appliedWalletBalance.amount}}
            </p>
            <p class="tw-ml-1 tw-font-body tw-text-300 tw-text-gray-500" i18n="@@cureskinCashApplied"> Cure Cash applied </p>
            <img class="tw-w-5 tw-h-5 tw-ml-2" src="/assets/images/correct_green.png" />
          </span>
        </div>
      </div>
    </section>
  }
</ng-template>

<ng-template #applyCashUI>
  @if (canPayFullyWithCureskinCash) {
    <div id="apply-cash" class="tw-bg-white tw-rounded-2 tw-relative tw-px-4 tw-py-3 tw-mt-4 tw-mb-2">
      <div class="tw-flex tw-gap-2 tw-items-center tw-relative"
        role="button"
        tabindex="0"
        (click)="toggleApplyCash()"
        (keydown.enter)="toggleApplyCash()"
        (keydown.space)="toggleApplyCash()">
        @if (applyCashSelected) {
          <div class="tw-h-6 tw-aspect-square tw-rounded-1 tw-border tw-border-teal-600 tw-bg-teal-600 tw-flex tw-items-center tw-justify-center">
            <svg
              class="tw-w-4 tw-h-4"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              >
              <path
                d="M6 12.5L10 16.5L18 8.5"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
            </svg>
          </div>
          <p class="tw-text-200 tw-font-body tw-flex tw-gap-1 tw-items-center tw-font-bold">
            <span>{{appliedCashAmountLabel}}</span>
            <span i18n="@@cureskinCashApplied"> Cure Cash applied </span>
          </p>
        } @else {
          <div class="tw-h-6 tw-aspect-square tw-rounded-1 tw-border tw-border-gray-400"></div>
          <p class="tw-text-200 tw-font-body tw-font-medium">
            <span i18n="@@applyWalletBalanceCureskinCash">Apply {{cashToApplyLabel}} Cure Cash</span>
            <img class="tw-w-4 tw-aspect-square tw-inline-block tw-mb-0.5 tw-ml-1" src="/assets/images/cureskin-cash-icon.png" alt="cash" />
          </p>
        }
        @if (showConfettiAnimation) {
          <ng-lottie
            class="tw-pointer-events-none tw-absolute -tw-top-20"
            width="100%"
            height="200px"
          [options]="options"></ng-lottie>
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #chooseCouponUI>
  @if (orderSP > 0 && coupons?.length) {
    <div class="bg-f4 pB10 tw-mb-6">
      <ng-container>
        <div class="or-choose-coupon" i18n="@@ChooseACouponCode"> Choose a coupon </div>
        <div class="choose-coupon">
          @for (coupon of coupons; track coupon) {
            <div class="coupon-item" (click)="applyCouponCode(coupon.code)">
              <radio-btn cssClass="mT7" [checked]="couponCode === coupon.code" (checkedChange)="couponCode = coupon.code">
                <div class="coupon-code" [ngClass]='{ "selected": couponCode == coupon.code }'>
                  {{coupon.code}}
                </div>
                @if (coupon.description) {
                  <div class="coupon-desc">
                    {{coupon.description}}
                  </div>
                }
              </radio-btn>
            </div>
          }
        </div>
      </ng-container>
    </div>
  }
</ng-template>

<ng-template #haveACouponCodeSection>
  @if (showOrderFlowCoupon) {
    @if (!showCouponsSection) {
      <section class="tw-flex tw-items-center tw-bg-yellow-100 tw-rounded-xl tw-px-4 tw-py-2 tw-justify-between tw-mx-5 tw-mt-5 tw-mb-6 tw-bg-white tw-shadow-z4" style="background: #f7f3d0" (click)="openCouponsSection()">
        <p class="tw-font-body tw-font-bold tw-text-black tw-text-300" i18n="@@haveACouponCode"> Have a coupon code? </p>
        <div class="tw-flex tw-items-center tw-gap-2 tw-text-200 tw-h-8 tw-border tw-border-black tw-rounded-full tw-px-4 tw-text-teal-600">
          <span class="tw-font-body tw-font-bold" i18n="@@apply">Apply</span>
          <cs-icon class="tw-h-4 tw-w-4" [iconName]='"chevron_right_teal"'></cs-icon>
        </div>
      </section>
    }
    @if (showCouponsSection) {
      <div class="coupon-container">
        <div class="coupon-textbox tw-rounded-2" id="coupon-box">
          <input #couponInput type="text" placeholder="Enter coupon code" [(ngModel)]="couponCode" [disabled]="couponLoading" autofocus="autofocus"/>
          <div class="apply" [ngClass]=" { 'clr-dark': couponCode } ">
            @if (!couponLoading) {
              <span i18n="@@apply" (click)="applyCoupon(selectedPaymentMode)">Apply</span>
            }
            @if (couponLoading) {
              <loading class="pos-abs vh-center" [scale]="0.7"></loading>
            }
          </div>
        </div>
      </div>
    }
  }
</ng-template>

<ng-template #noCodConfirmationFeeButtons>
  @if (orderSP !== 0 && selectedPaymentMode !== appConfig.Shared.Payment.paymentModes.COD) {
    <button csButton
      id="payButtonRebranded"
      data-testid="place-order"
      type="button"
      class="tw-w-full"
      style="border-radius: 9999px !important;"
      [disabled]="!selectedPaymentMode"
      [loading]="loading"
      (click)="placeOrder()"
      i18n="@@pay"
    >Pay</button>
  }
  @if (orderSP === 0 || selectedPaymentMode === appConfig.Shared.Payment.paymentModes.COD) {
    <button csButton
      id="placeOrderButtonRebranded"
      data-testid="place-order"
      type="button"
      class="tw-w-full"
      style="border-radius: 9999px !important;"
      [disabled]="!selectedPaymentMode"
      [loading]="loading"
      (click)="placeOrder()"
      i18n="@@placeYourOrder"
    >place your order</button>
  }
</ng-template>

<ng-template #sharePaymentLinkRow>
  @if (sharePaymentLinkEnabled && !isIOSDevice && orderSP > 0) {
    <div elementInViewport [viewportObserveOnce]="true" (enteredViewport)="logSharePaymentLinkImpression()" class="tw-flex tw-items-center tw-justify-between tw-px-5 tw-py-[18px] tw-border-t tw-border-gray-200 tw-cursor-pointer" (click)="openSharePaymentLinkSheet()">
      <div class="tw-flex tw-items-center tw-gap-3">
        <img class="tw-w-8 tw-h-8 tw-flex-shrink-0" src="/assets/icons/people-icon-payment-page.png" alt="share payment" />
        <div class="tw-flex tw-flex-col">
          <p class="tw-font-body tw-font-medium tw-text-300 tw-text-black" i18n="@@sharePaymentLink">Share payment link</p>
          <p class="tw-font-body tw-font-medium tw-text-200 tw-text-gray-400" i18n="@@sharePaymentLinkSubtext">Let a family member or friend<br/>pay for you</p>
        </div>
      </div>
      <img class="tw-w-6 tw-h-6 tw-flex-shrink-0" src="/assets/icons/teal-green-share-payment-page.png" alt="share" />
    </div>
  }
</ng-template>

<ng-template #paymentSelectionRadio let-paymentMethod="paymentMethod">
  @if (paymentMethod.mode === selectedPaymentMode) {
    <em
      class="tw-text-[28px] tw-w-[28px] tw-h-[28px] tw-inline-block tw-rounded-full tw-border tw-border-solid tw-border-teal-600 before:tw-contents-[''] before:tw-absolute before:tw-h-4 before:tw-w-4 before:tw-m-auto before:tw-left-0 before:tw-top-0 before:tw-bottom-0 before:tw-right-0 before:tw-text-center before:tw-rounded-full before:tw-bg-teal-600"
    ></em>
  }
  @if (paymentMethod.mode !== selectedPaymentMode) {
    <div
      class="tw-w-[28px] tw-h-[28px] tw-inline-block tw-rounded-full tw-border tw-border-solid tw-border-teal-600"
    ></div>
  }
</ng-template>
